import { useDispatch } from "react-redux";

import { AppState } from "../reducers";
import { AppDispatch } from ".";

export const useAppDispatch = () => useDispatch<AppDispatch<AppState>>();
